import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=311d6b4a&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=311d6b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../tianxinghuayi/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311d6b4a",
  null
  
)

export default component.exports